"use client";

import { memo } from "react";
import { useTranslations } from "next-intl";
import { ACTIVITY_CHART_COLORS } from "./constants";

/**
 * Компонент легенды для графика активности
 */
export const ActivityChartLegend = memo(function ActivityChartLegend() {
  const t = useTranslations();

  return (
    <div className="flex items-center gap-4 text-sm flex-wrap">
      <div className="flex items-center gap-1.5">
        <span
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: ACTIVITY_CHART_COLORS.normal }}
        />
        <span className="text-muted-foreground">
          {t("label-within-normal")}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: ACTIVITY_CHART_COLORS.exceeded }}
        />
        <span className="text-muted-foreground">
          {t("label-exceeds-normal")}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: ACTIVITY_CHART_COLORS.burst }}
        />
        <span className="text-muted-foreground">
          {t("label-suspicious-burst")}
        </span>
      </div>
    </div>
  );
});
